import { basepath } from "@app/enum/Path";
import AnnouncementCta from "@app/types/AnnouncementCta";

import { addAnnouncementsOffParam } from "./announcementsOffParam";
import { getNavigablePathForPageId } from "./pageRegistry";

// Both kinds open a new tab; the tab a page CTA opens shows no announcements.
const getAnnouncementCtaHref = (cta: AnnouncementCta): string | undefined => {
  if (cta.kind === "external") {
    return cta.externalUrl;
  }
  const path = getNavigablePathForPageId(cta.pageId);
  return path ? `${basepath}${addAnnouncementsOffParam(path)}` : undefined;
};

export default getAnnouncementCtaHref;
